module.exports = __webpack_public_path__ + "static/img/facialhair_03.dd7f3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/facialhair_03.png
// module id = IuBB
// module chunks = 0